import { h, Fragment } from "preact";

export default function DesignersLetters({ designers, idPrefix }) {
  const scrollIntoView = (e) => {
    e.preventDefault();

    const targetEl = document.querySelector(e.target.dataset.targetSelector);
    targetEl.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <>
      <div className="designers__letters-list-divider"></div>
      <div className="designers__letters-list-wrapper">
        <ul className="designers__letters-list">
          {designers.map((designer) => (
            <li className="designers__letters-list-item">
              <a
                href={`#${idPrefix}-${designer.title}`}
                className="designers__letter-link"
                data-target-selector={`#${idPrefix}-${designer.title}`}
                onClick={scrollIntoView}
              >
                {designer.title}
              </a>
            </li>
          ))}
        </ul>
      </div>
      <div className="designers__letters-list-divider"></div>
    </>
  );
}
